export default __webpack_public_path__ + "static/media/sponsor-icon-active.6d565e4a.webp";